export default "__VITE_ASSET__$0v4EMVd__"